import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { toast } from '../utils/toast';
import { getApiErrorMessage } from '@/utils/apiError';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const FirstLoginPasswordPage = () => {
  const navigate = useNavigate();
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (newPassword.length < 8) {
      toast.error('Password must be at least 8 characters long');
      return;
    }
    if (newPassword !== confirmPassword) {
      toast.error('Passwords do not match');
      return;
    }
    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      await axios.post(`${API}/auth/change-initial-password`,
        { new_password: newPassword, confirm_password: confirmPassword },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      // Clear the first-login flag on the cached user
      try {
        const u = JSON.parse(localStorage.getItem('user') || '{}');
        u.is_first_login = false;
        localStorage.setItem('user', JSON.stringify(u));
      } catch (err) { /* ignore */ }
      toast.success('Password updated. Welcome!');
      navigate('/dashboard');
    } catch (error) {
      toast.error(getApiErrorMessage(error, 'Failed to update password'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-xl p-8">
        <h1 className="text-2xl font-bold text-[#0056B3] mb-1">Set Your Password</h1>
        <p className="text-sm text-gray-600 mb-6">
          You're signing in with a temporary password. Please create a new password to continue.
        </p>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <Label>New Password *</Label>
            <Input
              type="password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              placeholder="Enter new password (min 8 characters)"
              autoComplete="new-password"
            />
          </div>
          <div>
            <Label>Confirm New Password *</Label>
            <Input
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              placeholder="Re-enter new password"
              autoComplete="new-password"
            />
          </div>
          <Button type="submit" disabled={loading} className="w-full bg-[#0056B3] hover:bg-[#0056B3]/90 text-white">
            {loading ? 'Saving…' : 'Set Password & Continue'}
          </Button>
        </form>
      </div>
    </div>
  );
};

export default FirstLoginPasswordPage;
